export const CREATE_STORY = 'CREATE_STORY';
export const CREATE_STORY_COMPLETE = 'CREATE_STORY_COMPLETE';

export const FETCH_STORY = 'FETCH_STORY';
export const FETCH_STORY_FAILED = 'FETCH_STORY_FAILED';
export const FETCH_STORY_SUCCESS = 'FETCH_STORY_SUCCESS';


export const FETCH_SINGLE_STORY = 'FETCH_SINGLE_STORY';
export const FETCH_SINGLE_STORY_COMPLETE = 'FETCH_SINGLE_STORY_COMPLETE';
export const FETCH_SINGLE_STORY_FAILED = 'FETCH_SINGLE_STORY_FAILED';
